<template>
    <simple-dropdown :dropdown-arrow="true" :alignment="1" :dropdown-wrapper-style="{padding: '0'}">
        <template v-slot:triggerButtonContent>
            <button class="pure button-account"><i class="gf gf-account"></i></button>
        </template>
        <template v-slot:dropdownMenu>
            <div class="dropdown-content">
                <div class="login-description">
                    <div class="main">
                        <div class="profile">
                            <div class="left">
                                <span class="profile-photo">{{userInfo.username[0]}}</span>
                            </div>
                            <div class="right">
                                <div class="username text-capitalize"><span>{{userInfo.username}}</span></div>
                                <div class="roles">
                                    <span class="item" v-if="userInfo.is_manager">Manager</span>
                                    <span v-else class="item">Analyst</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="bottom">
                        <button @click="logout">Logout</button>
                    </div>
                </div>
            </div>
        </template>
    </simple-dropdown>
</template>

<script>
    import SimpleDropdown from "@/components/SimpleDropdown";

    export default {
        name: "AccountButton",
        components: {SimpleDropdown},
        methods: {
            logout() {
                this.eventHub.$emit('doLogout');
            },
        },
        props: {
            userInfo: Object,
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/variables";

    .button-account.pure {
        font-size: 1.25rem;
        box-shadow: none;
    }

    .username {
        font-size: 1rem;
        font-weight: 500;
        color: #333333;
    }

    .main {
        padding: 1.8rem 1.5rem;
    }

    .profile {
        display: flex;
        align-items: center;

        .left {
            margin-right: 0.5rem;
        }
    }

    .roles {

        .item {
            color: #999999;
            font-weight: 500;
        }
    }

    .bottom {
        border-top: 1px solid #e3e3e3;
        background-color: #ececec;
        padding: 0.28rem;
        font-size: 0.86em;
        text-align: center;
    }

    .profile-photo {
        font-size: 1.35rem;
        width: 2.8rem;
        height: 2.8rem;
        border-radius: 50%;
        background-color: $primary-purple;
        color: rgba(white, 0.95);
        display: inline-flex;
        justify-content: center;
        align-items: center;
        text-transform: uppercase;
        font-weight: 500;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
        box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.36);
    }

</style>
